import React from 'react';
import { Stack, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { styles } from '../styles';
import { useQueryClient } from '@tanstack/react-query';
import { IIntegrationsResponse } from '../../types';
import formatToUserTimeZone from '../../../utils/formatToUserTimeZone';

export default function IntelliHrRecord() {
  const queryClient = useQueryClient();
  const integrationsData = queryClient.getQueryData<IIntegrationsResponse>(['integrations']);
  const intellihrRecord = integrationsData?.intellihr_record;

  if (!intellihrRecord) return null;
  return (
    <Stack sx={styles.integrationDetails}>
      <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Stack sx={{ fontSize: '16px', fontWeight: 600 }}>IntelliHR Export</Stack>
      </Stack>
      <Table sx={styles.integrationDetailsTable}>
        <TableHead>
          <TableRow>
            {['Exported at', 'IntelliHR ID', 'IntelliHR Display Name'].map((title, index) => (
              <TableCell sx={styles.integrationDetailsTableHeader} key={index}>
                <Stack>{title}</Stack>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ verticalAlign: 'top' }}>
              {formatToUserTimeZone(intellihrRecord.created_at)}
            </TableCell>
            <TableCell sx={{ verticalAlign: 'top' }}>{intellihrRecord.intellihr_id}</TableCell>
            <TableCell sx={{ verticalAlign: 'top' }}>{intellihrRecord.display_name}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Stack>
  );
}
